/** Opções de status na exportação de chamados (inclui novo e aguardando aprovação). */
export const TICKET_EXPORT_STATUS_OPTIONS = [
  { value: 'novo', label: 'Novo' },
  { value: 'aberto', label: 'Aberto' },
  { value: 'em_andamento', label: 'Em Andamento' },
  { value: 'aguardando_informacao_usuario', label: 'Aguardando Informação do Usuário' },
  { value: 'aguardando_terceiros', label: 'Aguardando Terceiros' },
  { value: 'aguardando_evidencia', label: 'Aguardando Evidência' },
  { value: 'aguardando_problema', label: 'Aguardando Problema' },
  { value: 'aguardando_implantacao', label: 'Aguardando Implantação' },
  { value: 'aguardando_aprovacao', label: 'Aguardando Aprovação' },
  { value: 'resolvido', label: 'Resolvido' },
  { value: 'fechado', label: 'Fechado' },
  { value: 'cancelado', label: 'Cancelado' },
] as const;

const ALLOWED = new Set(TICKET_EXPORT_STATUS_OPTIONS.map((option) => option.value));

export function ticketExportStatusesForFilter(selected: string[] | undefined): string[] {
  return (selected ?? []).filter((value) =>
    ALLOWED.has(value as (typeof TICKET_EXPORT_STATUS_OPTIONS)[number]['value']),
  );
}
